/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAutotaskCompanies200ResponseCompaniesInner } from './GetAutotaskCompanies200ResponseCompaniesInner';
import {
    GetAutotaskCompanies200ResponseCompaniesInnerFromJSON,
    GetAutotaskCompanies200ResponseCompaniesInnerFromJSONTyped,
    GetAutotaskCompanies200ResponseCompaniesInnerToJSON,
    GetAutotaskCompanies200ResponseCompaniesInnerToJSONTyped,
} from './GetAutotaskCompanies200ResponseCompaniesInner';

/**
 * 
 * @export
 * @interface GetAutotaskCompanies200Response
 */
export interface GetAutotaskCompanies200Response {
    /**
     * 
     */
    companies: Array<GetAutotaskCompanies200ResponseCompaniesInner>;
}

/**
 * Check if a given object implements the GetAutotaskCompanies200Response interface.
 */
export function instanceOfGetAutotaskCompanies200Response(value: object): value is GetAutotaskCompanies200Response {
    if (!('companies' in value) || value['companies'] === undefined) return false;
    return true;
}

export function GetAutotaskCompanies200ResponseFromJSON(json: any): GetAutotaskCompanies200Response {
    return GetAutotaskCompanies200ResponseFromJSONTyped(json, false);
}

export function GetAutotaskCompanies200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAutotaskCompanies200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'companies': ((json['companies'] as Array<any>).map(GetAutotaskCompanies200ResponseCompaniesInnerFromJSON)),
    };
}

export function GetAutotaskCompanies200ResponseToJSON(json: any): GetAutotaskCompanies200Response {
    return GetAutotaskCompanies200ResponseToJSONTyped(json, false);
}

export function GetAutotaskCompanies200ResponseToJSONTyped(value?: GetAutotaskCompanies200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companies': ((value['companies'] as Array<any>).map(GetAutotaskCompanies200ResponseCompaniesInnerToJSON)),
    };
}

